import * as angular from 'angular';
import { ChartDirectiveBase } from './ChartDirectiveBase';
import { Margins, ChartOptions, ShapeFormat } from '../../../models/index';
import { SvgManager } from '../../../charting/SvgManager';
import { ScatterPlot } from '../../../charting/index';
import { IDynamicCompileService } from '../../services/dynamicCompileService';

export interface IscatterplotDirective extends angular.IDirective {
}

export interface IScatterplotDirectiveScope extends angular.IScope {
    chartData: any;
    disableCrosshair: boolean;
    id: any;
    options: any;
    ratio?: number;
    series: any;
    shapes: ShapeFormat[];
    zoomControl: any;
}

export class ScatterPlotDirective extends ChartDirectiveBase implements IscatterplotDirective {
    static directiveId = 'wtScatterPlot';

    constructor(private _dynamicCompileService: IDynamicCompileService) {
        super();
        this.scope = {
            chartData: '=',
            disableCrosshair: '<?',
            id: '@',
            isZoomed: '=',
            options: '=',
            ratio: '<?',
            series: '=',
            shapes: '=?',
            zoomControl: '='
        };
        this.link.bind(this);
    }

    link = (scope: IScatterplotDirectiveScope, element: angular.IAugmentedJQuery, attrs, controller) => {
        const containerName = attrs.id;
        element.attr('id', containerName);
        const margins = new Margins(0, 0, 10, 0);
        const svgManager = new SvgManager(containerName, margins);
        const options = new ChartOptions(60, 10, 0, 50);
        const plot = new ScatterPlot(options, svgManager);

        scope.$watchCollection(() => scope.options.display, () => {
            plot.displayOptions(scope.options.display);
        });
        scope.$watch(() => scope.options.title, () => {
            plot.titleText(scope.options.title);
        });
        scope.$watch(() => scope.options.isTitleVisible, () => {
            plot.isTitleVisible(scope.options.isTitleVisible);
        });
        scope.$watch(() => scope.options.isLegendVisible, () => {
            plot.isLegendVisible(scope.options.isLegendVisible);
        });
        scope.$watch(() => scope.options.xAxis, () => {
            if (scope.options.xAxis) {
                scope.$watch(() => scope.options.xAxis.title, () => {
                    plot.xAxisTitle(scope.options.xAxis.title);
                });
                scope.$watch(() => scope.options.xAxis.min, () => {
                    plot.xAxisMin(scope.options.xAxis.min);
                });
                scope.$watch(() => scope.options.xAxis.max, () => {
                    plot.xAxisMax(scope.options.xAxis.max);
                });
                scope.$watch(() => scope.options.xAxis.valueSelector, () => {
                    plot.abscissValueSelector(scope.options.xAxis.valueSelector);
                });
                scope.$watch(() => scope.options.xAxis.isVisible, () => {
                    plot.isXAxisVisible(scope.options.xAxis.isVisible);
                });
            }
        });

        if (scope.options.yAxis) {
            scope.$watch(() => scope.options.yAxis.title, () => {
                plot.yAxisTitle(scope.options.yAxis.title);
            });
            scope.$watch(() => scope.options.yAxis.isVisible, () => {
                plot.isYAxisVisible(scope.options.yAxis.isVisible);
            });
            scope.$watch(() => scope.options.yAxis.min, () => {
                plot.yAxisMin(scope.options.yAxis.min);
            });
            scope.$watch(() => scope.options.yAxis.max, () => {
                plot.yAxisMax(scope.options.yAxis.max);
            });
        }

        scope.$watch(() => scope.disableCrosshair, (newValue: boolean) => {
            plot.disableCrosshair(!!newValue);
        });

        scope.$watch(() => scope.options.crosshairDate, (newValue: Date) => {
            plot.setCrosshair(newValue);
            // lineChart.updateCrosshair(chartOptions.crosshairDate);
        });

        plot.onCrosshair((date: Date) => {
            scope.options.crosshairDate = date;
            if (!scope.$$phase && !scope.$root.$$phase) {
                scope.$apply();
            }
        });
        if (!scope.zoomControl) {
            scope.zoomControl = {};
        }

        scope.zoomControl.isZoomed = () => {
            return plot.isZoomed();
        };

        scope.zoomControl.reset = () => {
            plot.resetZoom();
        };

        scope.$watchCollection(() => scope.chartData, () => {
            plot.update(scope.chartData);
        });

        scope.$watch(() => scope.series, () => {
            if (scope.series) {
                plot.updateSeries(scope.series);
                this._dynamicCompileService.compileGroup(element, scope);
            }
        }, true);
        scope.$watch(() => scope.shapes, () => {
            if (scope.shapes) {
                plot.shapes(scope.shapes);
            }
        });
        plot.bind(scope);

        scope.$watch(() => scope.ratio, () => {
            const { ratio } = scope;
            if (!!ratio) {
                svgManager.margins(new Margins(0, 0, 10 * ratio, 0));
                plot.ratio(ratio);
            }
        });
    }
}